// eslint-disable-next-line aloft/no-sui-chakra
import { chakra } from '@aloft/toolkit-sui/chakra';

import { getPinnedRowStyles } from '../getPinnedRowStyles.ts';
import { getRowStyles } from '../getRowStyles.ts';
import { RowProps } from '../types.ts';
import { Cell } from './Cell.tsx';

const groupRowEnterSx = {
  animation: 'toolkitGroupRowEnter 0.2s ease',
  '@keyframes toolkitGroupRowEnter': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
};

export const Row = <T,>({
  id,
  row,
  activeRowIndex,
  shouldPinFirstRow,
  handleRowClick,
  enableHoverStyle,
  pinnedColumnStyles,
  isSelected,
  customBackgroundColor,
  animateEnter,
}: RowProps<T>) => {
  if (!row) return null;

  const isActive = row.index === activeRowIndex;

  return (
    <chakra.tr
      id={id}
      {...getPinnedRowStyles(shouldPinFirstRow, row.index)}
      onClick={() => handleRowClick(row)}
      sx={{
        ...getRowStyles(isActive, !!isSelected, enableHoverStyle, customBackgroundColor),
        ...(animateEnter ? groupRowEnterSx : undefined),
      }}
    >
      {row.getVisibleCells().map((cell) => (
        <Cell
          key={`cell-${cell.id}`}
          cell={cell}
          shouldPinFirstRow={shouldPinFirstRow}
          pinnedColumnStyles={pinnedColumnStyles}
          rowIndex={row.index}
        />
      ))}
    </chakra.tr>
  );
};
